import { render, staticRenderFns } from "./AtomTextarea.vue?vue&type=template&id=3d2867f0&scoped=true"
import script from "./AtomTextarea.vue?vue&type=script&lang=js"
export * from "./AtomTextarea.vue?vue&type=script&lang=js"
import style0 from "./AtomTextarea.vue?vue&type=style&index=0&id=3d2867f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2867f0",
  null
  
)

export default component.exports